import React, { useEffect, useState, useContext } from 'react'
import { Form, Button, Input, message, DatePicker, Switch, Tooltip } from 'antd';
import { appContext } from "../../AppContext";
import { useFetch } from './../../utils/hooks/useFetch'
import moment from 'moment';
import { InfoCircleOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';

function useFormLayout()
{
    return {
        hideRequiredMark: true,
        colon: false,
        layout:"inline"
    }
}

export default function ProfileForm({
    originalLarper,
    refresh,
    setSomethingChanged,
    somethingChanged,
}) {
    const layout = useFormLayout();
    const [doFetch, FetchOptions] = useFetch();
    const [form] = Form.useForm()
    const [appState] = useContext(appContext);
    const [allowPhotos, setAllowedPhotos] = useState(originalLarper.privateInfo?.takePictures)
    const [isVega, setIsVega] = useState(originalLarper.privateInfo?.isVega)
    const [isVegan, setIsVegan] = useState(originalLarper.privateInfo?.isVegan)

    const [isUpdating, setIsUpdating] = useState(false)

    useEffect(() => {
        form.setFieldsValue({
            name: originalLarper.name,
            birthDate: originalLarper.privateInfo?.birthDate && moment(originalLarper.privateInfo?.birthDate),
            phoneNumber: originalLarper.privateInfo?.phoneNumber,
            emergencyNumber: originalLarper.privateInfo?.emergencyNumber,
            // photoRights: originalLarper.privateInfo?.takePictures,
            allergicInfo: originalLarper.privateInfo?.allergicInfo
        })

        setAllowedPhotos(originalLarper.privateInfo?.takePictures)
        setIsVega(originalLarper.privateInfo?.isVega)
        setIsVegan(originalLarper.privateInfo?.isVegan)
    },     //eslint-disable-next-line
    [form, originalLarper])
    
    function onUpdate(values)
    {
        setIsUpdating(true)

        const url = appState.user.isAdmin ? `/api/larper/adminupdate` : `/api/larper/update`
        const body = {
            id:originalLarper.id,
            name:values.name,
            privateInfo: {
                birthDate:values.birthDate,
                phoneNumber: values.phoneNumber,
                emergencyNumber: values.emergencyNumber,
                takePictures: allowPhotos,
                allergicInfo: values.allergicInfo,
                isVega: isVega,
                isVegan: isVegan
            }
        }
        
        doFetch(url, FetchOptions.POST, body)
            .then((response) => onFetchLoaded(response.isSuccess))

        function onFetchLoaded(isSuccess) {
            if(isSuccess) {
                refresh()
                message.success('The profile has been updated');
                setIsUpdating(false)
                setSomethingChanged(false);
                return;
            } 

            setIsUpdating(false)
            message.error('Could not update profile');
        }
    }


    function photosChanged(value) {
        setAllowedPhotos(value);
        setSomethingChanged(true)
    }

    function isVegaChanged(value) {
        setIsVega(value);
        setSomethingChanged(true)
    }

    function isVeganChanged(value) {
        setIsVegan(value);
        setSomethingChanged(true)
    }

    return (
        <>
            <Form 
                form={form}
                {...layout}
                name="basic"
                layout="horizontal"
                onFinish={onUpdate}>

                <br />
                    <Form.Item >
                        <Button
                            type="primary" 
                            htmlType="submit"
                            disabled={!somethingChanged}
                            loading={isUpdating}
                        >
                            Update Profile
                        </Button>
                    </Form.Item>

                    <Form.Item
                            label="Name"
                            name="name"
                        >
                            <Input name="name" onChange={() => setSomethingChanged(true)}/>
                    </Form.Item>

                    <Form.Item
                            label="BirthDate"
                            name="birthDate"
                        >
                            <DatePicker 
                                name="birthDate" 
                                onChange={() => setSomethingChanged(true)}
                                format={"DD/MM/YYYY"}
                            />
                    </Form.Item>

                    <Form.Item
                            label="Phone number"
                            name="phoneNumber"
                        >
                            <Input name="phoneNumber" onChange={() => setSomethingChanged(true)}/>
                    </Form.Item>

                    <Form.Item
                            label="Emergency phone number"
                            name="emergencyNumber"
                        >
                            <Input name="emergencyNumber" onChange={() => setSomethingChanged(true)}/>
                    </Form.Item>

                    <Form.Item
                            label="Allergies"
                            name="allergicInfo"
                        >
                            <TextArea  
                                name="allergicInfo" 
                                onChange={() => setSomethingChanged(true)}
                                rows={8}
                            />
                    </Form.Item>

                    <Form.Item
                        label="Allow photos to be taken during events"
                        name="photoRights"
                        tooltip={{ title: `In het kader van privacy vragen wij alle deelnemers om toestemming over de gemaakte foto's op een evenement. Deze foto's zullen met alle deelnemers gedeeld worden en in deze app geplaatst worden. Indien u dit niet wenst geef dit dan aan door op nee te clicken.`, icon: <InfoCircleOutlined /> }}

                    >
                        <Tooltip title={allowPhotos ? "Yes" : "No"}>
                            <Switch onChange={photosChanged} 
                                checked={allowPhotos}
                                />
                        </Tooltip>
                    </Form.Item>

                    <Form.Item
                        label="Vegetarian?"
                        name="isVega"
                    >
                        <Tooltip title={isVega ? "Yes" : "No"}>
                            <Switch onChange={isVegaChanged} 
                                checked={isVega}
                                />
                        </Tooltip>
                    </Form.Item>

                    <Form.Item
                        label="Vegan?"
                        name="isVegan"
                    >
                        <Tooltip title={isVegan ? "Yes" : "No"}>
                            <Switch onChange={isVeganChanged} 
                                checked={isVegan}
                                />
                        </Tooltip>
                    </Form.Item>
            </Form>
        </>
    )

}